import React, { useState, useRef } from "react";
import {
  Button,
  UnderlineButton,
  CustomModal,
  Alert,
  CardContainer
} from "../../components";
import html2canvas from "html2canvas";

export default function ButtonExamples() {

  const [isLoading, setIsLoading] = useState(false);

  const [alertMsg, setAlertMsg] = useState("");
  const [alertMsg2, setAlertMsg2] = useState("");

  const onClick = async (txt) => {
    try {
      setIsLoading(true);
      setTimeout(() => { setIsLoading(false); }, 2000)
      setAlertMsg(txt + " Button Clicked...")
    } catch (e) {
      alert("Error:" + e.message);
    }
  }

  const captureRef = useRef(null);

  /** @working_html2canvas_lib_사용 */
  const captureByHtml2canvasLib = async () => {
    setIsLoading(true)
    if (captureRef.current) {
      const canvas = await html2canvas(captureRef.current);
      // const canvas = await html2canvas(document.body);
      const imgData = canvas.toDataURL("image/jpeg");

      // 
      // Create a img element
      // 
      const img = document.createElement('img')
      img.src = imgData
      // img.style.cssText = 'margin: 10px; width: 300px'
      img.style.cssText = 'margin: 10px;'
      const aaa = document.getElementById("aaa")
      aaa.appendChild(img)

      // 
      // Create a link to download the image
      //
      const link = document.createElement("a");
      link.href = imgData;
      link.download = "screenshot-"+Date.now()+".png";
      link.click();
    }
    setIsLoading(false)
  };

  /** @not_working */
  const captureByPureJavascript = () => {
    const div = captureRef.current;
    if (!div) return;

    // Get the bounding rectangle of the div
    const rect = div.getBoundingClientRect();
    const width = rect.width;
    const height = rect.height;

    // Create a canvas and set its dimensions
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");

    // Convert the div content into an image
    _htmlToImage(div, canvas, ctx, width, height);
  }

  const _htmlToImage = (element, canvas, ctx, width, height) => {
    // Create an inline-styled clone of the div
    const clonedDiv = element.cloneNode(true);
    clonedDiv.style.position = "absolute";
    clonedDiv.style.left = "-9999px";
    document.body.appendChild(clonedDiv);

    // Convert div content to Blob
    const blob = new Blob([clonedDiv.outerHTML], { type: "text/html" });
    const url = URL.createObjectURL(blob);
    console.log('blob', blob)
    console.log('url', blob)

    // // Create an image element
    // const img = document.createElement('img')
    // ctx.drawImage(img, 0, 0, width, height);
    // URL.revokeObjectURL(url);
    // const imageUrl = canvas.toDataURL("image/png");

    // img.src = imageUrl;
    // const aaa = document.getElementById("aaa")
    // aaa.appendChild(img)

    const img2 = new Image()
    img2.onload = () => {

      console.log('img loaded')

      ctx.drawImage(img2, 0, 0, width, height);
      URL.revokeObjectURL(url);

      // Convert canvas to PNG image
      const imageUrl = canvas.toDataURL("image/png");
      document.getElementById("output").src = imageUrl;

      // Download the image
      const link = document.createElement("a");
      link.href = imageUrl;
      link.download = "div-image.png";
      link.click();

      // Remove cloned div
      document.body.removeChild(clonedDiv);
    };
    img2.src = url;
  };

  const onClickOutlineButton = async (txt) => {
    try {
      setIsLoading(true);
      setTimeout(() => { setIsLoading(false); }, 2000);
      setAlertMsg2(txt + " Button Clicked...")
    } catch (e) {
      alert("Error:" + e.message);
    }
  }

  const myStyle = {
    btnsWrap: {
      display: 'flex',
      justifyContent: 'space-between', alignItems: "center",
      width: '100%',
      flexWrap: "wrap",
      marginBottom: "10px"
    },
    captureBlock: {
      padding: "20px 15px 10px",
      backgroundColor: "#333",
      borderRadius: 10
    }
  }

  return (
    <CardContainer>
      <div ref={captureRef} style={myStyle.captureBlock}>
        <div style={myStyle.btnsWrap}>
          {["primary", "info", "secondary",].map((type, i) =>
            <Button
              key={i}
              variant={type}
              width="150px"
              title={type + " lg"}
              onClick={() => onClick(type)}
              isLoading={isLoading}
            />
          )}

        </div>

        <div style={myStyle.btnsWrap}>
          {["outline-primary", "outline-info", "outline-secondary",].map((type, i) =>
            <Button
              key={i}
              variant={type}
              width="150px"
              title={type}
              onClick={() => onClickOutlineButton(type)}
              isLoading={isLoading}
            />
          )}
        </div>
      </div>

      <div style={myStyle.btnsWrap}>
        <UnderlineButton
          isLoading={isLoading}
          title="이미지 캡처"
          // onClick={onClick}
          onClick={captureByHtml2canvasLib}
          // onClick={captureByPureJavascript} // not working
        />
      </div>

      <div id="aaa" style={{ display: "flex", flexDirection: "column" }}>
        {/* <img id="output" alt="captured" /> */}
      </div>

      <Alert
        title={alertMsg} visible={alertMsg !== ""}
        onClickOk={() => setAlertMsg("")}
      />

      <CustomModal
        title={alertMsg2} visible={alertMsg2 !== ""}
        onClickOk={() => setAlertMsg2("")}
        onClickCancel={() => setAlertMsg2("")}
      />
    </CardContainer>
  )
}